module.exports = __webpack_public_path__ + "static/media/5 vor 12.b4ac45ec.ogg";